<table class="weaveTableEdit">
  <thead>
    @for (field of fields; track field) {
      <th>
        {{field.label}}@if (field.required) {
        *
      }
    </th>
  }
</thead>
<tbody>
  @for (rowLabel of rowLabels; track rowLabel; let i = $index) {
    <tr>
      @for (field of fields; track field) {
        <td>
          @if (field.type === 'html') {
            <div class="labelCell" [innerHTML]="rowLabel.content"></div>
          }
          @if (field.type === 'input') {
            <app-weave-input
              [data]="values[i][field.propertyName]"
              [placeholder]="field.placeholder || ''"
              [showError]="showErrors"
              [required]="field.required"
              (focusOut)="emitValues(values[i], field.propertyName, $event)"
            ></app-weave-input>
          }
          @if (field.type === 'email') {
            <app-weave-email
              [data]="values[i][field.propertyName]"
              [placeholder]="field.placeholder || ''"
              [showError]="showErrors"
              [required]="field.required"
              (focusOut)="emitValues(values[i], field.propertyName, $event)"
            ></app-weave-email>
          }
          @if (field.type === 'currency') {
            <app-weave-currency
              [data]="values[i][field.propertyName]"
              [placeholder]="field.placeholder || ''"
              [showError]="showErrors"
              [required]="field.required"
              (focusOut)="emitValues(values[i], field.propertyName, $event)"
            ></app-weave-currency>
          }
          @if (field.type === 'percentage') {
            <app-percentage-input
              [data]="values[i][field.propertyName]"
              [placeholder]="field.placeholder || ''"
              [showError]="showErrors"
              [required]="field.required"
              (focusOut)="emitValues(values[i], field.propertyName, $event)"
            ></app-percentage-input>
          }
          @if (field.type === 'select' || field.type == 'prefixSelect' || field.type === 'degreeSelect') {
            <app-weave-select
              [showLabel]="false"
              [data]="values[i][field.propertyName]"
              [options]="field.selectValues"
              (focusOut)="emitValues(values[i], field.propertyName, $event)"
              [showError]="showErrors"
              [required]="field.required"
            ></app-weave-select>
          }
        </td>
      }
    </tr>
  }
</tbody>
</table>

